export default __webpack_public_path__ + "static/media/magadhi_lang.cffd9443.png";